import { Component, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { FieldTypeTextSimpleComponent } from '../field-type-text/field-type-text-simple/field-type-text-simple.component';
import { FieldTypeNumberComponent } from '../field-type-number/field-type-number.component';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ActivatedRoute } from '@angular/router';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
    selector: 'new-contact',
    templateUrl: './new-contact.component.html',
    standalone: true,
    imports: [NgClass, AfTranslateDirective, FieldTypeTextSimpleComponent, FieldTypeNumberComponent]
})
export class NewContactComponent implements OnInit {
  configuration: any = this.dialogConfig.data;
  skin: string = this.globalCfg.skin;
  newContact:any = {
    contactProperties: ['name','surname','nif','position','companyname','address','postalCode','city', 'province', 'country','email','phonenumber1','phonenumber2'],
    new:{
      name: '',
      surname:'',
      position:'',
      companyname:'',
      email:'',
      phonenumber1:'',
      phonenumber2:'',
      address:'',
      postalCode:'',
      city:'',
      province:'',
      country:''
    }
  };
  constructor(private route: ActivatedRoute,
    private dialogRef: DynamicDialogRef<NewContactComponent>,
    private dialogConfig: DynamicDialogConfig,
    private globalCfg: GlobalCfgFactory,
    private translate: AfTranslateFactory,
    private loader: LoaderFactory,
    private apiService: ApiServiceService,
    private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService) { }

  ngOnInit(): void {
    this.configureContactProperties();
  }

  configureContactProperties(){
    this.newContact.contactProperties.forEach((property: any)=>{
      let labelTranslate = this.getLabelTranslate(property)
      let propertyTranslate = property === 'companyname'?'company':property;
      this.newContact[property] = {
          label: this.translate.instant(labelTranslate+propertyTranslate),
          fieldId: property+'-'+this.commonUtilsService.createId(),
          required: (property === 'name' || property === 'surname' || property === 'email'),
          description: null,
          fieldTypeId: (property === 'phonenumber1' || property === 'phonenumber2' || property === 'postalCode')?'num':'text'
      }
      if(property === 'phonenumber1' || property === 'phonenumber2' || property === 'postalCode'){
          this.newContact[property].positive = true;
      }
    })
  }

  getLabelTranslate(property: any){
    if(property === 'nif'){
      return 'users-admin.person-form.';
    }else{
      return (property === 'phonenumber1' || property === 'phonenumber2' || property === 'postalCode')?'new-contact.':'common.';
    }
  }

  itemSelected(type: any, newValue: any){
    this.newContact.new[type] = newValue;
  }

  createNew(){
    if(this.validateFieldsForm()){
        if(this.newContact.new.contactId){
            delete this.newContact.new.contactId;
        }
        let evaluationId = this.route.snapshot.params['evaluationId'] || this.route.snapshot.firstChild?.params['evaluationId'];
        if(this.configuration.valueId && this.configuration.option !== 'Client' && !evaluationId){
            evaluationId = this.configuration.valueId;
        }
        if(this.configuration.option === 'Client'){
          this.newContact.new.clients = [{
            clientId: this.configuration.valueId
          }]
        }
        let url = 'contacts';
        if(evaluationId){
            url = 'contacts/toevaluation/' + evaluationId;
        }
        this.loader.openLoader('add-new-contact');
        this.apiService.add(url, this.newContact.new)
          .then((data:any)=>{
            data.fullName = this.newContact.new.name + ' ' + this.newContact.new.surname
            let newContact = {
                address:      data.address,
                city:         data.city,
                companyName:  data.companyName,
                contactId:    data.contactId,
                country:      data.country,
                email:        data.email,
                fullName:     data.fullName,
                listValueId:  'C-'+data.contactId,
                name:         data.name ,
                phoneNumber1: data.phoneNumber1,
                phoneNumber2: data.phoneNumber2,
                position:     data.position,
                postalCode:   data.postalCode,
                province:     data.province,
                surname:      data.surname,
                type:         'C',
                typeItem:     'contact',
                typeOrder:    3,
                uniqueValueId:'C-'+data.contactId
            }
            this.loader.closeLoader('add-new-contact');
            this.modalService.successModal({ text: this.translate.instant('new-contact.contact-created') })
            this.handleAccept(newContact);
          }, (errorData:any)=>{
            this.loader.closeError();
            this.modalService.errorModal({ text: this.translate.instant('common.unexpected-error') });
          });
    }else{
      this.modalService.errorModal({text: this.translate.instant('users-admin.main.contact-edit-error')})
    }
  }

  validateFieldsForm() {
    this.newContact.name.error = (this.newContact.new.name === '');
    this.newContact.surname.error = (this.newContact.new.surname === '');
    this.newContact.email.error = (this.newContact.new.email === '' || !this.commonUtilsService.validateMail(this.newContact.new.email));
    return (!this.newContact.name.error && !this.newContact.surname.error && !this.newContact.email.error);
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }

  handleAccept(newContact: any) {
    this.dialogRef.close({
        result: 'ok',
        newContact: newContact
    })
  }

}
